<template>
  <div class="chat-widget-completed">
    <v-icon
      size="18"
      color="success"
      class="chat-widget-completed__icon"
    >
      mdi-check-circle
    </v-icon>
    <div class="chat-widget-completed__body">
      <p class="text-body-2 font-weight-medium mb-0">
        {{ displayTitle }}
      </p>
      <div
        v-if="widget.imageUrl"
        class="chat-widget-completed__thumb mt-2"
      >
        <r-img
          :src="widget.imageUrl"
          contain
          class="chat-widget-completed__img"
        />
      </div>
      <div
        v-else-if="widget.hex"
        class="chat-widget-completed__color d-flex align-center ga-2 mt-1"
      >
        <span
          class="chat-widget-completed__swatch"
          :style="{ backgroundColor: widget.hex }"
        />
        <span class="text-caption">{{ widget.hex.toUpperCase() }}</span>
      </div>
      <p
        v-else
        class="text-caption text-medium-emphasis mb-0 mt-1"
      >
        {{ widget.summary }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CompletedInlineWidget } from '@/stores/aiAssistant/types'

const props = defineProps<{
  widget: CompletedInlineWidget
}>()

// Titles derived from field labels arrive lowercase (they read mid-sentence in
// chat prompts); capitalize the first letter for this heading.
const displayTitle = computed((): string => {
  const raw = props.widget.title?.trim() ?? ''
  return raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : raw
})
</script>

<style scoped>
.chat-widget-completed {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.chat-widget-completed__icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.chat-widget-completed__swatch {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.chat-widget-completed__thumb {
  width: 120px;
  max-width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(var(--v-theme-on-surface), 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.chat-widget-completed__img {
  width: 100%;
  max-height: 120px;
}
</style>
